import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { AppauthService } from '../../common/guards/auth.app.services';

// tslint:disable-next-line: no-empty-interface
export interface DialogData {
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.sass']
})


export class ModalComponent {
  submitted = false;
  contactForm = new FormGroup({
    fname: new FormControl('', Validators.required),
    sname: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
    company: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    subject: new FormControl(''),
    recaptchaReactive: new FormControl(null, Validators.required),
  });

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    private authService: AppauthService) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // Resolved for Google Captcha
  public resolved(captchaResponse: any) {
   this.contactForm.controls.recaptchaReactive.setValue(captchaResponse);
  }

   // Body Message
  createMessageBody() {
    const body = '<!DOCTYPE html>\n' +
      '<html>\n' +
      '    <head>\n' +
      '        <title>Marcus Evans Case Studies - We have received your request and we will be in touch soon!</title>' +
      '        <meta charset="utf-8" />' +
      '        <style>\n' +
      '            body {font-family : Calibri}' +
      '        </style>' +
      '    </head>' +
      '    <body style="padding:10px;margin:10px !important; ">' +
      '        <h2>Enquiry Details</h2>' +
      `        <p><b>First Name</b>: ${this.contactForm.controls.fname.value}</p> ` +
      `        <p><b>Surname</b>: ${this.contactForm.controls.sname.value}</p> ` +
      `        <p><b>Email Address</b>: ${this.contactForm.controls.email.value}</p> ` +
      `        <p><b>Company Name</b>: ${this.contactForm.controls.company.value}</p> ` +
      `        <p><b>Message</b>: ${this.contactForm.controls.subject.value}</p> ` +
      '    </body>' +
      '</html>';

    return body;
  }


  onSubmit() {
    this.submitted = true;
    const emailRequest = {
      EmailType: environment.emailType,
      EmailTo: environment.emailTo,
      EmailCC: '',
      Subject: 'Re:- Case Study Information Request',
      Body: this.createMessageBody(),
      Provider: environment.emailProvider
    };
    //this.authService.isFormSubmitted(emailRequest, this.contactForm.controls.fname.value, this.dialogRef);
  }
}
